import styled from "@emotion/styled"
import { useRecoilValue } from "recoil"
import { useTranslation } from "react-i18next"
import { useCallback, useRef, useMemo, useState, useEffect } from "react"

import { Dropdown } from "../../common"
import { InputWrapper } from "../../styles/common.styled"
import { brandingSelector, roomSelector } from "../../../recoil/atoms/room"
import { useResizeObserver } from "../../../hooks/useResizeObserver"
import { getOpacity, isRGBAcolor, replaceOpacity } from "../../../util"
import {
  ModerationSettingsItem,
  ModerationSettingsList,
  ModerationSettingsName,
  ModerationSubTitle
} from "./moderation.styled"
import useMeetingClient from "../../../hooks/useMeetingClient"
import { VideoProfileEncoderType } from "../../../context/types"

export const Input = styled.input`
  width: 100%;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: white;
  border: 2px solid #e2e8f0;
  border-left: none;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  padding: 0.3rem 0.75rem;
`

  

const VideoProfileDropDown = () => {
  const inputWrapper = useRef<HTMLDivElement>(null)
  const [widthInputWrapper] = useResizeObserver(inputWrapper)
  const { t } = useTranslation()
  const roomStyles = useRecoilValue(brandingSelector)
  const { streamingResolution } = useRecoilValue(roomSelector)

  const StreamingResolutions = useMemo(() => window.MeetOnline.StreamingResolutions, [])
  const StreamingResolutionList: VideoProfileEncoderType[] = useMemo(() => Object.values(StreamingResolutions), [StreamingResolutions])

  const [selectedVideoProfile, setSelectedVideoProfile] = useState(
    StreamingResolutionList?.[0]
  )

  useEffect(() => {
    setSelectedVideoProfile(StreamingResolutions[streamingResolution])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [streamingResolution])

  const meetingClient = useMeetingClient()

  const handleOnChange = useCallback((item: VideoProfileEncoderType) => {
    meetingClient?.changeRoomSetting({
      streamingResolution: item.id
    })
    setSelectedVideoProfile(item)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const сolorBorder = useMemo<string>(() => {
    if (isRGBAcolor(roomStyles?.servicePanelElementBorder)) {
      return getOpacity(roomStyles?.servicePanelElementBorder) > 0.3
        ? replaceOpacity(
            roomStyles?.servicePanelElementBorder,
            getOpacity(roomStyles?.servicePanelElementBorder) - 0.3
          )
        : replaceOpacity(roomStyles?.servicePanelElementBorder, 0.1)
    }
    return `${roomStyles?.servicePanelElementBorder}b3` ?? "#28a745"
  }, [roomStyles?.servicePanelElementBorder])

  return (
    <InputWrapper
      isSmallWindowHeight={false}
      ref={inputWrapper}
      style={{ display: "flex", flexDirection: "row" }}
    >
      <Dropdown
        label={t("Video")}
        onChange={handleOnChange}
        list={StreamingResolutionList}
        сolorBorder={сolorBorder}
        emptyText={t("Empty devices")}
        roomStyles={roomStyles}
        customstyles={{
          item: {
            width: `${widthInputWrapper - 4}px`,
            fontSize: "0.8rem",
            padding: "0.25rem 0.5rem"
          },
          button: {
            padding: "0.3rem 0.75rem",
            fontSize: "0.9rem"
          }
        }}
      />
      <Input
        style={{
          border: `2px solid ${сolorBorder}`,
          backgroundColor: roomStyles.servicePanelElementBackground,
          color: roomStyles?.servicePanelElementPrimaryText,
          borderLeft: "none"
        }}
        type="text"
        disabled
        value={selectedVideoProfile?.label || ""}
      />
    </InputWrapper>
  )
}

const StreamResolutionSetting = () => {
  const { t } = useTranslation()
  const roomStyles = useRecoilValue(brandingSelector)

  return (
    <>
      <ModerationSubTitle
        style={{ color: roomStyles?.servicePanelElementSecondaryText }}
      >
        {t("STREAM RESOLUTION ")}
      </ModerationSubTitle>
      <ModerationSettingsList>
        <ModerationSettingsItem key={10001}>
          <ModerationSettingsName roomStyles={roomStyles}>
            {t(
              "For detailed video you may wish to increase the video resolution"
            )}
          </ModerationSettingsName>
        </ModerationSettingsItem>
      </ModerationSettingsList>
      <VideoProfileDropDown />
    </>
  )
}
export default StreamResolutionSetting
